import { css } from 'styled-components';
import { commonTheme } from './common-theme';
import { colors } from '../../atoms/colors/colors';
import { LoaderTags } from '../../atoms/loader/class-name-tags';
import { complementaryColors } from '../../atoms/colors/complementary-colors';
import { addAlpha } from '../../atoms/colors/utils';
export const loadingButtonDarkTheme = {
    primary: css `
    & .${LoaderTags.spinningBar} {
      stroke: ${colors.ultramarine900};
    }

    & .${LoaderTags.circle} {
      stroke: ${colors.warmgrey300};
    }
  `,
    secondary: css `
    & .${LoaderTags.spinningBar} {
      stroke: ${colors.warmgrey300};
    }

    & .${LoaderTags.circle} {
      stroke: ${colors.ultramarine900};
    }
  `,
    ghost: css `
    & .${LoaderTags.spinningBar} {
      stroke: ${colors.warmgrey300};
    }

    & .${LoaderTags.circle} {
      stroke: ${colors.ultramarine900};
    }
  `,
    negative: css `
    & .${LoaderTags.spinningBar} {
      stroke: ${colors.ultramarine900};
    }

    & .${LoaderTags.circle} {
      stroke: ${colors.warmgrey300};
    }
  `,
    text: css `
    & .${LoaderTags.spinningBar} {
      stroke: ${colors.ultramarine300};
    }

    & .${LoaderTags.circle} {
      stroke: ${colors.ultramarine900};
    }
  `,
};
export const buttonDarkTheme = {
    ...commonTheme,
    loadingButton: loadingButtonDarkTheme,
    primary: css `
    ${commonTheme.primary}
    background-color: ${colors.sunset300};
    border-color: ${colors.sunset300};
    color: ${colors.ultramarine900};

    &:hover {
      background-color: ${colors.sunset100};
      border-color: ${colors.sunset100};
    }

    &.disabled {
      background-color: ${complementaryColors.golden};
      border-color: ${complementaryColors.golden};
      color: ${complementaryColors.ultramarine950};
    }

    &:active:not(.disabled) {
      background-color: ${colors.sunset500};
      border-color: ${colors.sunset500};
    }
  `,
    secondary: css `
    ${commonTheme.secondary}
    background-color: transparent;
    border-color: ${colors.warmgrey500};
    color: ${colors.warmgrey300};

    &:hover {
      background-color: ${addAlpha(colors.warmgrey700, 0.5)};
    }

    &:disabled {
      border-color: ${complementaryColors.warmgrey650};
      background-color: ${addAlpha(colors.warmgrey800, 0.4)};
      color: ${complementaryColors.warmgrey550};

      & svg {
        color: ${complementaryColors.warmgrey650};
      }
    }
    &:active:not(.disabled) {
      background-color: ${colors.warmgrey700};
    }
  `,
    ghost: css `
    ${commonTheme.ghost};
    color: ${colors.warmgrey300};
    &:hover {
      background-color: ${addAlpha(colors.warmgrey700, 0.5)};
      border-color: ${addAlpha(colors.warmgrey700, 0.5)};
    }

    &.disabled {
      border-color: ${addAlpha(colors.warmgrey800, 0.4)};
      background-color: ${addAlpha(colors.warmgrey800, 0.4)};
      color: ${complementaryColors.warmgrey550};
    }

    &:active:not(.disabled) {
      border-color: ${colors.warmgrey700};
      background-color: ${colors.warmgrey700};
    }
  `,
    text: css `
    ${commonTheme.text}
    color: ${colors.ultramarine300};

    &:hover {
      color: ${colors.ultramarine200};
    }

    &.disabled {
      color: ${addAlpha(colors.ultramarine300, 0.5)};
    }

    &:active:not(.disabled) {
      color: ${colors.ultramarine100};
    }
  `,
};
//# sourceMappingURL=dark-theme.js.map